/**
 * This module contains all of our feature flags. Our feature flag library is intentionally simple
 * and client-only. Define your flag here, and use the `useFeatureFlag` custom hook to determine if
 * it's enabled.
 *
 * End-users should user their console directly to enable or disable features using the `ff` global,
 * like so:
 *
 * ```js
 * // See all available feature flags
 * ff.list();
 *
 * // Enable a flag
 * ff.on('flag-name');
 *
 * // Disable a flag
 * ff.off('flag-name');
 * ```
 */

import { FeatureFlagsRepository } from '~/util/FeatureFlagsRepository';

export const featureFlags = new FeatureFlagsRepository( localStorage, {
  /**
   * This isn't really a feature we'll ever expose. It's a sloppy location for unpolished and
   * unsupported tools that might be helpful to engineers.
   */
  'developer-tools': {
    description: 'Show the developer tools feature',
  },
  'customer-rewrite': {
    description: 'Show features related to the rewrite of the customer interface',
  },
} );
